import {
    Button,
    IconChevronLeft,
} from '@snsw-gel/react';
import {
    ButtonsContainer,
} from '@gaas/gaas-react-component-library';
import React from 'react';
import TollReliefConfig from '../../config/TollReliefConfig';

interface ManageTollAccountNavigationButtonProps {
    readonly hasAnyLinkedAccounts: boolean;
}

/**
 * A button to either navigate to toll tracker,
 * or to navigate back, out of MTA.
 */
const ManageTollAccountNavigationButton: React.FC<ManageTollAccountNavigationButtonProps> = ({hasAnyLinkedAccounts}) => {
    return <>
        <ButtonsContainer>
            {hasAnyLinkedAccounts && <Button
                variant='primary'
                onClick={() => window.location.assign(TollReliefConfig.urls.tollTrackerURL)}
            >
                View Toll Tracker
            </Button>}
        </ButtonsContainer>
        <Button
            iconStart={<IconChevronLeft/>}
            variant='link'
            onClick={() => window.location.replace(TollReliefConfig.urls.tollReliefRebateSchemeURL)}
        >
            Exit
        </Button>
    </>;
}

export default ManageTollAccountNavigationButton;
